
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";

export const initDownloadButton = (lightbox) => {
  const downloadIcon = <MwlIcons icon={'download'} />;

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'download-button',
      order: 10,
      isButton: true,
      html: renderToString(downloadIcon),
      onClick: () => {
        const currSlideData = lightbox.pswp.currSlide.data;
        const href = currSlideData.meta.download;
        const anchor = document.createElement('a');
        anchor.href = href;
        anchor.download = href.split(/[\\/]/).pop();
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },
    });
  });
};